<template>
    <div>
        <configs-content :loading="!loaded">
            <h2 class="flex items-center text-3xl mb-4">
                <nio-icon class="mr-2" name="regular/messages-bubble-settings" />
                {{ $t('configs.rightPanel.messages.subtitles.messages') }}
            </h2>

            <automated-messages :loading="!loaded" :show-payment-message="hasAccessToPayment" :user="user" />
        </configs-content>

        <configs-footer>
            <nio-button
                color="blue"
                :disabled="!loaded || displayCrmConfirmationError"
                :loading="saving"
                @click="saveConfigs"
            >
                {{ $t('global.general.save') }}
            </nio-button>
        </configs-footer>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import cloneDeep from 'lodash/cloneDeep.js';
    import assign from 'lodash/assign.js';
    import AutomatedMessages from '@/components/User/AutomatedMessages.vue';
    import ConfigsContent from '@/components/ConfigsContent.vue';
    import ConfigsFooter from '@/components/ConfigsFooter.vue';
    import MessageParsing from '@/mixins/MessageParsing.js';

    export default {
        components: {
            AutomatedMessages,
            ConfigsContent,
            ConfigsFooter,
        },

        mixins: [MessageParsing],

        data() {
            return {
                saving: false,
                loaded: false,
                user: {
                    id: null,
                    related_id: null,
                    options: {
                        unsubscribe_message: {
                            fr: '',
                            en: '',
                        },
                        confirmation_message: {
                            fr: '',
                            en: '',
                        },
                        crm_confirmation_message: {
                            fr: '',
                            en: '',
                        },
                        payment_message: {
                            fr: '',
                            en: '',
                        },
                        append_confirmation_message: true,
                        quick_send: true,
                        notifications: {
                            message_received: {
                                email: false,
                                screen: true,
                            },
                        },
                    },
                },
                activeTab: 'fr',
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapGetters([
                'hasAccessToPayment',
            ]),

            displayCrmConfirmationError() {
                if (empty(this.user.options.crm_confirmation_message.en) &&
                    empty(this.user.options.crm_confirmation_message.fr)
                ) {
                    return true;
                }

                return false;
            },
        },

        watch: {
            authUser(newValue) {
                this.mergeWithoutAdding(this.user, newValue);

                this.$nextTick(() => {
                    this.loaded = true;
                });
            },
        },

        methods: {
            ...mapActions([
                'setAuthUser',
            ]),

            ...mapActions('setting', [
                'updateUser',
            ]),

            saveConfigs() {
                this.saving = true;

                this.user.options.crm_confirmation_message = this.duplicateTranslationIfEmpty(this.user.options.crm_confirmation_message);

                this.updateUser(this.user)
                    .then(user => {
                        this.saving = false;

                        // Update authUser
                        const newAuthUser = assign(cloneDeep(this.authUser), user);
                        this.setAuthUser(newAuthUser);

                        this.$notify.show({
                            type: 'success',
                            message: this.$t('configs.rightPanel.messages.messages.updateSuccessful'),
                        });
                    })
                    .catch(() => {
                        this.saving = false;

                        this.$notify.show({
                            type: 'error',
                            message: this.$t('configs.rightPanel.messages.errors.update'),
                        });
                    });
            },
        },
    };
</script>
